export class LinkedDocument {
	documentId: string;
	documentTitle: string;
	factId: string;
	caseId: string;
	pageNumber: number;

}
